export default {"src":"/_next/static/media/logout.428cc06a.svg","height":15,"width":15};